<template>
  <section>
    <div class="form-group">
      <label>
        Vendor Menu &emsp;
        <a
            type="button"
            @click="copyValueToClipboard"
            title="Copy Link"
            class="fa-lg"
        >
          <i class="fa fa-files-o"/>
        </a>
        | <a
            type="button"
            @click="downloadMenu"
            title="Download QR code"
            class="fa-lg"
        >
          <i class="fa fa-download"/>
        </a>
      </label>
      <input id="branchMenuLink"
             disabled="disabled"
             :value="encryptNumber(branchId)"
             type="text"
             class="form-control"
             placeholder="Branch Menu">

      <VueQrcode
          id="MenuQRcode"
          hidden="true"
          :value="encryptNumber(branchId)"
          :options="{ width: 500}">
      </VueQrcode>
    </div>
  </section>
</template>

<script>
import cryptoJs from 'crypto-js'
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
  name: "BranchMenuComponent",
  props: ["branchId", "branchName"],
  components: {
    VueQrcode
  },
  data() {
    return {
      sauce: 'OkKYetiB4@dy'
    }
  },
  methods: {
    encryptNumber(number) {
      const encryptedValue = cryptoJs.AES.encrypt(number + '', this.sauce).toString().replaceAll('+', 'xMl3Jk').replaceAll('/', 'Por21Ld').replaceAll('=', 'Ml32');
      return "https://menu.bayked.co/" + encryptedValue;
    },

    copyValueToClipboard: function (){
      let branchMenuLink = $("#branchMenuLink").val();
      navigator.clipboard.writeText(branchMenuLink).then( () => {
        swal("SUCCESS!", "Successfully Copy Branch Menu Link!", "success");
      }).catch( ex => {
        console.log("Error: ", ex);
        swal("ERROR!", "Error while copying branch menu link!", "error");
      })
    },
    downloadMenu: function (){
      const canvas = document.getElementById("MenuQRcode");
      const pngUrl = canvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");

      let downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = this.branchName.replaceAll(" ", "-") + ".png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }
}
</script>
